import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Free, no-key IP geolocation. We cache for 24h in localStorage.
const CACHE_KEY = "wfw_geo_v1";
const TTL_MS = 24 * 60 * 60 * 1000;

// Convert ISO country code (e.g. "MX") into flag emoji.
export const flagEmoji = (code) => {
  if (!code || code.length !== 2) return "🌍";
  const cc = code.toUpperCase();
  const A = 0x1f1e6;
  return String.fromCodePoint(A + cc.charCodeAt(0) - 65, A + cc.charCodeAt(1) - 65);
};

const readCache = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.ts || Date.now() - parsed.ts > TTL_MS) return null;
    return parsed.data;
  } catch { return null; }
};

const writeCache = (data) => {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data })); } catch { /* ignore */ }
};

export const useGeo = () => {
  const [geo, setGeo] = useState(() => readCache());
  const [loading, setLoading] = useState(!geo);

  useEffect(() => {
    if (geo) return;
    let active = true;
    (async () => {
      try {
        // Prefer backend proxy (avoids CORS, more reliable)
        const { data: j } = await axios.get(`${API}/geo`);
        const data = {
          country: j.country || "your country",
          countryCode: (j.country_code || "").toUpperCase(),
          city: j.city || "",
        };
        if (!active) return;
        writeCache(data);
        setGeo(data);
      } catch {
        // Silent fallback: generic worldwide
        if (active) setGeo({ country: "your country", countryCode: "", city: "" });
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [geo]);

  return { geo, loading };
};
